import React from "react";

var FlowSwitch = function FlowSwitch(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

export default FlowSwitch;